import React, { useEffect, useState } from 'react';
import Module from '../../../../layout/Module';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import ButtonStartIcon from '../../../../button/ButtonStartIcon';
import useSubjects from '../../../../../hooks/subjects/useSubjects';
import { Alert } from '@mui/material';
import AlertSaveButton from '../../../../button/AlertSaveButton';
import isEmpty from 'lodash/isEmpty';
import { toggleAlertModule } from '../../../../../store/actions/alert.actions';
import { updateSubjectError, updateSubjectFormField } from '../../../../../store/actions/subjects.actions';
import { Box, Typography } from '@mui/material';
import Form from '../Form/Form';

const Create = () => {
  const { createSubject } = useSubjects();
  const dispatch = useDispatch();
  const formData = useSelector((state) => state?.subject?.form);
  const alertSave = useSelector((state) => state?.alert?.save || {});
  const permission = useSelector((state) => state?.session?.permissions?.subject || {});
  const { curriculumId } = useParams();
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const [loading, toggleLoading] = useState(false);

  const onCancel = () => {
    navigate(`/dashboard/subjects/${curriculumId}`);
    dispatch(toggleAlertModule(null));
  };

  const onChangeAlert = (key, value) => {
    dispatch(updateSubjectFormField(key, value));
    if (key === 'curriculumId') {
      dispatch(updateSubjectFormField('curriculumElements', {}));
      dispatch(updateSubjectFormField('curriculumelements', {}));
    }
    if (!alertSave.mode || !alertSave.onSave) {
      dispatch(toggleAlertModule(false, 'Subjects', 'create', onSubmit, alertSave.onDontSave));
    }
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    toggleLoading(true);
    try {
      let result = await createSubject({ ...formData });
      if (result.error) {
        const { message, error, ...rest } = result;
        if (message) {
          setError({ message });
        } else {
          dispatch(updateSubjectError(rest));
        }
      } else {
        onCancel();
      }
    } finally {
      toggleLoading(false);
    }
  };

  useEffect(() => {
    if (isEmpty(formData)) {
      onCancel();
    }
  }, [formData]);

  return (
    <>
      <Module.BodyHeader className='border-b border-b-2 border-primary flex justify-between'>
        <Typography variant='subtitle1' className='text-primary'>
          Create subject
        </Typography>
        <div className='flex items-center justify-end gap-2'>
          <AlertSaveButton
            submodule='Users'
            icon={['fal', 'times']}
            title='Cancel'
            color='primary'
            variant='outlined'
            className='shadow-sm w-full'
            onDontSave={onCancel}
          />
          {permission.created && (
            <ButtonStartIcon
              disabled={loading}
              loading={loading}
              onClick={onSubmit}
              startIcon={['fal', 'check']}
              color='primary'
            >
              Save
            </ButtonStartIcon>
          )}
        </div>
      </Module.BodyHeader>
      <Module.BodyContainer loading={loading} classNameWrapper={loading ? '' : 'overflow-auto'}>
        <Box className={['absolute inset-0 pb-2 pt-6 px-4'].join(' ')}>
          {error?.message && (
            <Alert severity='error' className='mb-4' onClose={() => setError(null)}>
              {error?.message}
            </Alert>
          )}
          <Form onChangeAlert={onChangeAlert} />
        </Box>
      </Module.BodyContainer>
    </>
  );
};

export default Create;
